export default __webpack_public_path__ + "static/media/Home.87588987.png";